const meal = {
  id: "",
  name: null,
  foods: [],
  description: null,
  type: [],
  price: null,
  groups: [],
  quantity: 0,
  measure: "kg",
  newSelectedName: null,
  image_id: null,
  shift_one: 0,
  shift_two: 0,
  shift_three: 0,
  one: 0,
};

const mealColor = {
  dorucak: "green",
  rucak: "blue",
  vecera: "red",
};

export { meal, mealColor };
